export const validateWithCodi = async (text, context) => {
  const token = localStorage.getItem("token");

  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/codi/validate-text`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ text, context })
    });

    const result = await res.json();
    return result;
  } catch (err) {
    console.error("❌ Codi validation failed:", err);
    return { valid: true }; // fallback — don’t block
  }
};
